import React from "react";

import AppPlaceholderPhoto from "@common/assets/images/shared-icons/app-icon-placeholder.svg";
import Header from "@common/components/Header/Header";
import Navigation, { NavItem } from "@common/components/Navigation/Navigation";
import Tooltip from "@common/components/Tooltip/Tooltip";
import { Platform, PlatformOs } from "@common/models";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import { getOSImage } from "@common/util/contentResolvers";
import identifiers from "@common/util/identifiers.json";
import AppListDropdown from "@main/layouts/components/PageNavigation/AppListDropdown";
import OverlayText from "@public/layouts/components/OverlayText/OverlayText";

import * as Styled from "./AppListDropdown.styles";

export const PAGE_NAVIGATION_ELEMENT_ROOT_ID = "page-navigation-element-root";
export const ELEMENT_CONTAINER_ID = "element-container-main";
export const NAV_LIST = "nav_list";

interface Props {
  bottomBorder?: boolean;
  bottomBorderColor?: string;
  overlayText?: React.ReactNode;
}

export const PageNavigation = ({ bottomBorder, bottomBorderColor, overlayText }: Props) => {
  return (
    <>
      <Header
        bottomBorder={bottomBorder}
        styles={{
          position: "relative",
          borderBottomColor: bottomBorderColor,
        }}
      >
        <OverlayText text={overlayText} />
        <Navigation elementId={NAV_LIST}>
          <NavItem withClick={false}>
            <Styled.Disabled>
              <span>Feedback</span>
            </Styled.Disabled>
          </NavItem>
          <NavItem>
            <Styled.Disabled>
              <Styled.SelectedAppWithOptions>
                <Styled.SelectedAppContainer data-testid={identifiers["navbar.selectedApp.button"]}>
                  <Tooltip
                    disabled={true}
                    position="bottom"
                    text={"Example app"}
                  >
                    <Flex
                      $alignItems="center"
                      style={{ paddingLeft: "0.8rem" }}
                    >
                      <img
                        src={AppPlaceholderPhoto}
                        width={28}
                        height={28}
                        style={{ borderRadius: "0.8rem", objectFit: "cover" }}
                        alt={"AppPlaceholderPhoto"}
                      />
                      <Styled.SelectedApp>
                        <Styled.AppNameParagraph>Example app</Styled.AppNameParagraph>
                        <img
                          src={getOSImage({ os: PlatformOs.WEB } as Platform)}
                          width={20}
                          height={20}
                          alt={"OsImage"}
                        />
                      </Styled.SelectedApp>
                      <Styled.Down />
                    </Flex>
                  </Tooltip>
                </Styled.SelectedAppContainer>
                <AppListDropdown
                  disabled={true}
                  appList={[]}
                  onAppSwitch={() => 0}
                  isDropdownMenuOpen={false}
                  setIsDropdownMenuOpen={() => ({})}
                />
              </Styled.SelectedAppWithOptions>
            </Styled.Disabled>
          </NavItem>
        </Navigation>
      </Header>
    </>
  );
};
